import consumer from "./consumer"

const initCallCable = (onIncomingCall) => {
  const callChannel = consumer.subscriptions.create(
    { channel: "CallChannel" },
    {
      received(data) {
        if (data.type === "incoming_call") {
          onIncomingCall(data.from);
        }
      },

      sendCall(identity) {
        this.perform("start_call", { from: identity });
      }
    }
  );

  return callChannel;
};

export { initCallCable };
